<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-bathtub`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43.996 12.216C43.846 6.548 39.204 2 33.5 2h-1l-.295.004C27.398 2.137 23.398 5.5 22.299 10h4.199l.099-.225A6.501 6.501 0 0132.5 6h1l.233.004A6.5 6.5 0 0140 12.5V23H3a1 1 0 00-1 1v2a1 1 0 001 1h1v4.6l.004.279c.129 4.659 3.484 8.522 7.996 9.73V45a1 1 0 001 1h2a1 1 0 001-1v-3h15v3a1 1 0 001 1h2a1 1 0 001-1v-3.172c5.101-.887 9-5.104 9-10.228V27h1a1 1 0 001-1v-2a1 1 0 00-1-1h-1V12.5l-.004-.284zM8 27h32v4.6l-.004.223C39.867 35.225 36.813 38 33 38H15l-.248-.004C10.974 37.876 8 35.028 8 31.6V27zm21-12a3 3 0 110 6 3 3 0 010-6zm-7.007-1.176A2.999 2.999 0 0016 14l.005.176A2.999 2.999 0 0021.998 14l-.005-.176z"/></svg>
</template>
<script>

export default {
  name: 'IconBathtub',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
